import ERROR_REASONS from "@shared/payments/error-reasons.json"
import INTENT_TYPES from "@shared/payments/intent-types.json"

export const PAYMENT_METHOD_TYPES = {
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay",
  PAYMENT_REQUEST: "payment_request",
  CREDIT_CARD: "credit_card"
}

export const STAGES = {
  START: "#checkout",
  PAY: "#checkout/pay",
  CALLBACK: "#checkout/callback",
  PAY_IAP: "#checkout/pay/iap",
  ERROR: "#checkout/error",
  PRODUCTS: "#checkout/products",
  REACTIVATE: "#checkout/reactivate"
}

// This is used to allow us to open the CheckoutModal to confirm a setup
// intent callback, without actually setting up with relation to any specific product
// Useful for when you want to just update a payment method using a setupIntent
export const SETUP_INTENT_PRODUCT_ID = "SETUP_INTENT_PRODUCT"

export const CALLBACK_PARAMS = {
  PRODUCT_ID: "product_id",
  SETUP_INTENT: "setup_intent"
}

export const generateReturnURL = (location, productId = null) => {
  const query = productId ? `?${CALLBACK_PARAMS.PRODUCT_ID}=${productId}` : ""

  return location.origin + location.pathname + query + STAGES.CALLBACK
}

export const paymentMethodType = paymentRequestResponse =>
  !paymentRequestResponse
    ? PAYMENT_METHOD_TYPES.CREDIT_CARD
    : paymentRequestResponse.applePay
    ? PAYMENT_METHOD_TYPES.APPLE_PAY
    : paymentRequestResponse.googlePay
    ? PAYMENT_METHOD_TYPES.GOOGLE_PAY
    : PAYMENT_METHOD_TYPES.PAYMENT_REQUEST

export { ERROR_REASONS, INTENT_TYPES }
